<template>
  <div class="row no-wrap">
    <div class="column q-pr-md">
      <div class="stepper-ball flex items-center justify-center">
        {{ step }}
      </div>
      <div class="stepper-line-container q-my-sm flex-1">
        <div
          v-if="!isLastStep"
          class="stepper-line"
        />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "FormStep",
  props: {
    step: {
      type: Number,
      default: 1,
    },
    isLastStep: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper-ball {
  background-color: $hover-background;
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.stepper-line-container {
  position: relative;
}

.stepper-line {
  border-left: 1px solid $hover-background;
  position: absolute;
  left: 50%;
  height: 100%;
}
</style>
